<template>
  <div class="row options">
    <div v-for="(option, index) in options" :key="index" class="col-sm-4 col-6" :class="{ 'col-md-2': option.length >= 6 }">
      <component :is="option.type + 'Option'" :key="option.id" :option="option" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import SelectOption from './selectOption'
import CountOption from './countOption'

export default {
  components: {
    selectOption: SelectOption,
    countOption: CountOption,
    checkOption: SelectOption
  },
  computed: {
    ...mapGetters({
      options: 'configurator/currentOptions',
      step: 'configurator/currentStep'
    })
  }
}
</script>
